// src/routes/router.jsx
import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import AuthGate from "./AuthGate";
import ProtectedRoute from "../components/ProtectedRoute";

// KO 레이아웃
import LoginContainer from "../pages/Auth/containers/LoginContainer";
import SignupContainer from "../pages/Auth/containers/SignupContainer";
import UserEditContainer from "../pages/Auth/containers/UserEditContainer";
import FindPasswordContainer from "../pages/Auth/containers/FindPasswordContainer";
import ProfilingPage from "../pages/Profiling/ProfilingPage";
import ReviewPage from "../pages/Review/ReviewPage";
import DictionaryPage from "../pages/Dictionary/DictionaryPage";
import SimulationPage from "../pages/Simulation/SimulationPage";
import TrainingFollowupPage from "../pages/TrainingFollowup/TrainingFollowupPage";
import TrainingPage from "../pages/Training/TrainingPage";
import TrainingResponsePage from "../pages/TrainingResponse/TrainingResponsePage";
import ChartingPage from "../pages/Charting/ChartingPage";
import MemoTalkPage from "../pages/MemoTalk/MemoTalkPage";
import SmallTalkPage from "../pages/SmallTalk/SmallTalkPage";
import AnalysisPage from "../pages/Analysis/AnalysisPage";
import EducationPage from "../pages/Education/EducationPage";

// CN 레이아웃
import CNLayout from "../cn/CNLayout";
import LoginContainerCN from "../cn/pages/Auth/containers/LoginContainerCN";
import SignupContainerCN from "../cn/pages/Auth/containers/SignupContainerCN";
import UserEditContainerCN from "../cn/pages/Auth/containers/UserEditContainerCN";
import ProfilingPageCN from "../cn/pages/Profiling/ProfilingPageCN";
import ReviewPageCN from "../cn/pages/Review/ReviewPageCN";
import DictionaryPageCN from "../cn/pages/Dictionary/DictionaryPageCN";
import SimulationPageCN from "../cn/pages/Simulation/SimulationPageCN";

// ✅ 신규 CN 페이지들(이번에 KO에서 추가된 것들)
import TrainingFollowupPageCN from "../cn/pages/TrainingFollowup/TrainingFollowupPageCN";
import TrainingPageCN from "../cn/pages/Training/TrainingPageCN";
import TrainingResponsePageCN from "../cn/pages/TrainingResponse/TrainingResponsePageCN";
import ChartingPageCN from "../cn/pages/Charting/ChartingPageCN";
import MemoTalkPageCN from "../cn/pages/MemoTalk/MemoTalkPageCN";
import SmallTalkPageCN from "../cn/pages/SmallTalk/SmallTalkPageCN";
import AnalysisPageCN from "../cn/pages/Analysis/AnalysisPageCN";
import EducationPageCN from "../cn/pages/Education/EducationPageCN";

// adm
import AdmLayout from "../adm/AdmLayout";
import AdmGate from "../adm/AdmGate";
import AdmLogin from "../adm/pages/Login";
import BranchPage from "../adm/pages/Branch";
import UserPage from "../adm/pages/User";
import UserDayLogPage from "../adm/pages/UserDayLog";
import UserTimeLog from "../adm/pages/UserTimeLog";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <AuthGate /> },
      { path: "login", element: <LoginContainer /> },
      { path: "signup", element: <SignupContainer /> },
      { path: "find-password", element: <FindPasswordContainer /> },
      { path: "user_edit", element: <UserEditContainer /> },
      {
        path: "profiling",
        element: (
          <ProtectedRoute>
            <ProfilingPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "review",
        element: (
          <ProtectedRoute>
            <ReviewPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "dictionary",
        element: (
          <ProtectedRoute>
            <DictionaryPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "simulation",
        element: (
          <ProtectedRoute>
            <SimulationPage />
          </ProtectedRoute>
        ),
      },
      { path: "training-followup", element: <TrainingFollowupPage /> },
      { path: "training", element: <TrainingPage /> },
      { path: "training-response", element: <TrainingResponsePage /> },
      { path: "charting", element: <ChartingPage /> },
      { path: "memotalk", element: <MemoTalkPage /> },
      { path: "smalltalk", element: <SmallTalkPage /> },
      { path: "analysis", element: <AnalysisPage /> },
      { path: "education", element: <EducationPage /> },

      {
        path: "cn",
        element: <CNLayout />,
        children: [
          { index: true, element: <AuthGate /> },
          { path: "login", element: <LoginContainerCN /> },
          { path: "signup", element: <SignupContainerCN /> },
          { path: "user_edit", element: <UserEditContainerCN /> },
          {
            path: "profiling",
            element: (
              <ProtectedRoute>
                <ProfilingPageCN />
              </ProtectedRoute>
            ),
          },
          {
            path: "review",
            element: (
              <ProtectedRoute>
                <ReviewPageCN />
              </ProtectedRoute>
            ),
          },
          {
            path: "dictionary",
            element: (
              <ProtectedRoute>
                <DictionaryPageCN />
              </ProtectedRoute>
            ),
          },
          {
            path: "simulation",
            element: (
              <ProtectedRoute>
                <SimulationPageCN />
              </ProtectedRoute>
            ),
          },

          // ✅ KO 신규 페이지들 CN 라우팅 추가
          { path: "training-followup", element: <TrainingFollowupPageCN /> },
          { path: "training", element: <TrainingPageCN /> },
          { path: "training-response", element: <TrainingResponsePageCN /> },
          { path: "charting", element: <ChartingPageCN /> },
          { path: "memotalk", element: <MemoTalkPageCN /> },
          { path: "smalltalk", element: <SmallTalkPageCN /> },
          { path: "analysis", element: <AnalysisPageCN /> },
          { path: "education", element: <EducationPageCN /> },
        ],
      },
      { path: "*", element: <div>Not Found</div> },
    ],
  },
  {
    path: "/adm",
    element: <AdmLayout />,
    children: [
      { index: true, element: <AdmGate home="branch" /> },
      { path: "login", element: <AdmLogin /> },
      { path: "branch", element: <BranchPage /> },
      { path: "user", element: <UserPage /> },
      { path: "userDayLog", element: <UserDayLogPage /> },
      { path: "userTimeLog", element: <UserTimeLog /> },
      { path: "*", element: <div>Not Found</div> },
    ],
  },
]);
